import React from 'react';
import { Modal, Button, Row, Col, Form, Spinner, Table } from 'react-bootstrap';
import SmartSearchSelect from "../../../components/Smart/SmartSearchSelect";

export default function AssignShopsModal({
    show,
    onHide,
    isGlobalAdmin,
    loadingOptions,
    assignmentMode,
    selectedSupplier,
    selectedLocation,
    supplierOptions,
    globalLocationOptions,
    scopedLocationOptions,
    modalShops,
    modalSelection,
    selectAll,
    onAssignmentModeChange,
    onSupplierChange,
    onLocationChange,
    onToggleSelectAll,
    onToggleOne,
    onConfirm,
}) {
    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Choose Shops</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {isGlobalAdmin ? (
                    <Row className="g-3 align-items-end">
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label className="fw-semibold mb-2">How would you like to find shops?</Form.Label>
                                <Form.Select
                                    value={assignmentMode}
                                    onChange={(e) => onAssignmentModeChange(e.target.value)}
                                >
                                    <option value="">Select assignment mode...</option>
                                    <option value="supplier">Search by supplier</option>
                                    <option value="city">Search by location</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>

                        {assignmentMode === 'supplier' && (
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label className="fw-semibold mb-2">Supplier</Form.Label>
                                    <SmartSearchSelect
                                        currentID={selectedSupplier}
                                        options={(supplierOptions || []).map((s) => ({
                                            ...s,
                                            value: String(s.id),
                                            label: s.companyName || s.name,
                                        }))}
                                        onChange={(selected) => onSupplierChange(selected?.value || '')}
                                        placeholder="Choose a supplier..."
                                        noOptionsMessage="No suppliers found"
                                    />
                                </Form.Group>
                            </Col>
                        )}

                        {assignmentMode === 'city' && (
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label className="fw-semibold mb-2">Location</Form.Label>
                                    <SmartSearchSelect
                                        currentID={selectedLocation}
                                        options={(globalLocationOptions || []).map((loc) => ({
                                            ...loc,
                                            value: String(loc.value),
                                            label: loc.label,
                                        }))}
                                        onChange={(selected) => onLocationChange(selected?.value || '')}
                                        placeholder="Choose a country, city, or location..."
                                        noOptionsMessage="No locations found"
                                    />
                                </Form.Group>
                            </Col>
                        )}
                    </Row>
                ) : (
                    <Row className="g-3 align-items-end">
                        <Col md={12}>
                            <Form.Group>
                                <Form.Label className="fw-semibold mb-2">Locations</Form.Label>
                                <SmartSearchSelect
                                    currentID={selectedLocation}
                                    options={(scopedLocationOptions || []).map((loc) => ({
                                        ...loc,
                                        value: String(loc.value),
                                        label: loc.label,
                                    }))}
                                    onChange={(selected) => onLocationChange(selected?.value || '')}
                                    placeholder="Choose a location..."
                                    noOptionsMessage="No locations found"
                                />
                                <Form.Text className="text-muted">
                                    You can only see locations and shops available to your company.
                                </Form.Text>
                            </Form.Group>
                        </Col>
                    </Row>
                )}

                {loadingOptions && (
                    <div className="mt-3 d-flex align-items-center gap-2 text-muted">
                        <Spinner animation="border" size="sm" />
                        <span>Finding available shops...</span>
                    </div>
                )}

                {!loadingOptions && selectedLocation && modalShops.length === 0 && (
                    <div className="mt-3 text-muted">
                        No shops found in this location.
                    </div>
                )}

                {!loadingOptions && assignmentMode === 'supplier' && selectedSupplier && modalShops.length === 0 && (
                    <div className="mt-3 text-muted">
                        No shops found for this supplier.
                    </div>
                )}

                {modalShops.length > 0 && (
                    <>
                        <div className="d-flex justify-content-between align-items-center mt-3 mb-2">
                            <span className="fw-semibold">Available shops ({modalShops.length})</span>
                            <Form.Check
                                label="Select all shops"
                                checked={selectAll}
                                onChange={(e) => onToggleSelectAll(e.target.checked)}
                            />
                        </div>

                        <Table striped bordered hover responsive>
                            <thead>
                                <tr>
                                    <th style={{ width: 40 }} />
                                    <th>Location</th>
                                    <th>Supplier</th>
                                    <th>Shop name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {modalShops.map((s, idx) => {
                                    const checked = !!modalSelection[s.id];

                                    return (
                                        <tr
                                            key={s.id ?? idx}
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => onToggleOne(s.id, !checked)}
                                        >
                                            <td onClick={(e) => e.stopPropagation()}>
                                                <Form.Check
                                                    checked={checked}
                                                    onChange={(e) => onToggleOne(s.id, e.target.checked)}
                                                />
                                            </td>
                                            <td>{s.locationName}</td>
                                            <td>{s.companyName}</td>
                                            <td>{s.name}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    </>
                )}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancel
                </Button>
                <Button variant="primary" disabled={modalShops.length === 0} onClick={onConfirm}>
                    Add selected shops
                </Button>
            </Modal.Footer>
        </Modal>
    );
}